import {
  StyledLobbyContainer,
  StyledLink,
  StyledTabContentTitle,
  StyledLinkContainer,
  StyledLinkImage,
} from './styled'
import ticketsStore from '../../../../../assets/images/tickets_store.jpg'
import ticketsStoreEn from '../../../../../assets/images/tickets_store_EN.jpg'
import hapoelsShop from '../../../../../assets/images/hapoels_shop.jpg'
import hapoelsShopEn from '../../../../../assets/images/hapoel_shop_EN.jpg'
import { useSelector } from 'react-redux'
import { RootState } from 'store/store'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { ELanguage } from 'types/enums/ELanguage'

//TODO: add correct links
export const Lobby = () => {
  const languageCode = useSelector(
    (state: RootState) => state.layout.language.code,
  )
  const { t } = useTranslation('', {
    keyPrefix: 'pages.personalArea.tabs.lobby',
  })

  const [ticketsStoreImage, setTicketsStoreImage] = useState(
    languageCode === ELanguage.HEBREW ? ticketsStore : ticketsStoreEn,
  )
  const [hapoelsShopImage, setHapoelsShopImage] = useState(
    languageCode === ELanguage.HEBREW ? hapoelsShop : hapoelsShopEn,
  )

  useEffect(() => {
    switch (languageCode) {
      case ELanguage.ENGLISH:
        setTicketsStoreImage(ticketsStoreEn)
        setHapoelsShopImage(hapoelsShopEn)
        break
      default:
        setTicketsStoreImage(ticketsStore)
        setHapoelsShopImage(hapoelsShop)
    }
  }, [languageCode])

  return (
    <StyledLobbyContainer>
      <StyledTabContentTitle>{t('text')}</StyledTabContentTitle>
      <StyledLinkContainer>
        <StyledLink
          to="https://tickets.hapoel.co.il/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <StyledLinkImage src={ticketsStoreImage} alt="" />
        </StyledLink>

        <StyledLink
          to="https://www.shop.hapoel.co.il/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <StyledLinkImage src={hapoelsShopImage} alt="" />
        </StyledLink>
      </StyledLinkContainer>
    </StyledLobbyContainer>
  )
}
